import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

export default class extends Controller {
  static values = { targetFrameId: String }

  showSkeleton(event) {
    if (this.hasTargetFrameIdValue) {
      const skeleton = document.getElementById('skeleton_template').innerHTML
      document.getElementById(this.targetFrameIdValue).innerHTML = skeleton
    }
  }

  toggleRadio(event) {
    const currentRadio = event.currentTarget
    const wasChecked = currentRadio.dataset.wasChecked === 'true'

    const name = currentRadio.name
    document.querySelectorAll(`input[name="${name}"]`).forEach(radio => delete radio.dataset.wasChecked)

    if (wasChecked && currentRadio.id !== "filter_dates_custom") {
      currentRadio.checked = false
      currentRadio.dispatchEvent(new Event('change', { bubbles: true }))
    } else {
      currentRadio.dataset.wasChecked = 'true'
    }
  }

  showQuickActionsSkeleton(event) {
    const link = event.currentTarget
    if (link.href) {
      event.preventDefault()

      if (this.hasTargetFrameIdValue) {
        const skeleton = document.getElementById('skeleton_template').innerHTML
        document.getElementById(this.targetFrameIdValue).innerHTML = skeleton;
        visit(link.href, { frame: this.targetFrameIdValue })
      } else {
        visit(link.href)
      }

    } else if (this.hasTargetFrameIdValue) {
      const skeleton = document.getElementById('skeleton_template').innerHTML
      document.getElementById(this.targetFrameIdValue).innerHTML = skeleton
    }
  }
}
